import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTwitter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.5557 3.33301L16.0322 3.73633L11.3711 9.25293L17.1602 16.7344C17.306 16.9228 17.3322 17.1777 17.2276 17.3916C17.1225 17.6057 16.9045 17.7422 16.666 17.7422H13.333C13.1358 17.7421 12.95 17.6483 12.832 17.4902L8.86525 12.1748L4.18751 17.8955L3.70314 17.5L3.21974 17.1035L8.09572 11.1426L2.83204 4.08984C2.69083 3.90037 2.66848 3.6468 2.77443 3.43555C2.88046 3.22444 3.09677 3.09089 3.33302 3.09082H6.29591L6.36818 3.09473C6.53394 3.11398 6.68654 3.1996 6.79005 3.33301L10.5889 8.24219L15.0781 2.92969L15.5557 3.33301ZM9.38966 10.7871L13.6465 16.4922H15.3926L10.0733 9.61914L5.98927 4.34082H4.57911L9.38966 10.7871Z",
		fill: "white"
	})
});
export default SvgTwitter;
